/**
 * Formats a total number of seconds into a human-readable countdown string.
 * Returns "Xh Ym Zs", "Ym Zs", "Zs", or "0s".
 *
 * @param {number} totalSeconds
 * @returns {string}
 */
export const formatCountdown = (totalSeconds) => {
  if (totalSeconds <= 0) {
    return '0s'
  }
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`
  }
  return `${seconds}s`
}
